import React, { useState, useContext } from 'react';
import { Card, CardBody, Col, Container, Input, Label, Row, Button, Form, FormFeedback, Alert, Spinner } from 'reactstrap';
import ParticlesAuth from './ParticlesAuth';
import { Link, useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import logoLight from '../../assets/images/logo-light.png';
import { AuthContext } from '../../context/AuthContext';

const Login = () => {
  const { signIn, loading, error } = useContext(AuthContext);
  const [passwordShow, setPasswordShow] = useState(false);
  const navigate = useNavigate();

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      userName: '',
      password: '',
    },
    validationSchema: Yup.object({
      userName: Yup.string().required('لطفاً نام کاربری را وارد کنید'),
      password: Yup.string().required('لطفاً رمز عبور را وارد کنید'),
    }),
    onSubmit: async (values) => {
      try {
        await signIn(values.userName, values.password, navigate);
      } catch (err) {
        // خطا در AuthContext مدیریت می‌شه
      }
    },
  });

  document.title = 'مدیریت فات 90 | ورود';

  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className="auth-page-content">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="text-center mt-sm-5 mb-4 text-white-50">
                  <div>
                    <Link to="/" className="d-inline-block auth-logo">
                      <img src={logoLight} alt="" height="20" />
                    </Link>
                  </div>
                  <p className="mt-3 fs-15 fw-medium text-dark">پنل اختصاصی فات 90</p>
                </div>
              </Col>
            </Row>

            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="mt-4">
                  <CardBody className="p-4">
                    <div className="text-center mt-2">
                      <h5 className="text-primary">خوش آمدید !</h5>
                      <p className="text-muted">برای ادامه وارد سیستم شوید.</p>
                    </div>
                    {error && <Alert color="danger">{error}</Alert>}
                    <div className="p-2 mt-4">
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                        action="#"
                      >
                        <div className="mb-3">
                          <Label htmlFor="userName" className="form-label">
                            نام کاربری
                          </Label>
                          <Input
                            name="userName"
                            className="form-control"
                            placeholder="نام کاربری را وارد نمایید"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.userName}
                            invalid={!!(validation.touched.userName && validation.errors.userName)}
                          />
                          {validation.touched.userName && validation.errors.userName ? (
                            <FormFeedback>{validation.errors.userName}</FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-3">
                          <Label className="form-label" htmlFor="password-input">
                            رمز عبور
                          </Label>
                          <div className="position-relative auth-pass-inputgroup mb-3">
                            <Input
                              name="password"
                              value={validation.values.password}
                              type={passwordShow ? 'text' : 'password'}
                              className="form-control pe-5"
                              placeholder="رمز عبور را وارد نمایید"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              invalid={!!(validation.touched.password && validation.errors.password)}
                            />
                            {validation.touched.password && validation.errors.password ? (
                              <FormFeedback>{validation.errors.password}</FormFeedback>
                            ) : null}
                            <button
                              className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                              onClick={() => setPasswordShow(!passwordShow)}
                              type="button"
                              id="password-addon"
                            >
                              <i className="ri-eye-fill align-middle"></i>
                            </button>
                          </div>
                        </div>

                        <div className="form-check">
                          <Input className="form-check-input" type="checkbox" value="" id="auth-remember-check" />
                          <Label className="form-check-label" htmlFor="auth-remember-check">
                            مرا به خاطر بسپار
                          </Label>
                        </div>

                        <div className="mt-4">
                          <Button
                            color="success"
                            disabled={loading}
                            className="btn btn-success w-100"
                            type="submit"
                          >
                            {loading ? (
                              <Spinner size="sm" className="me-2">
                                در حال انجام عملیات ...
                              </Spinner>
                            ) : null}
                            ورود به سیستم
                          </Button>
                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default Login;